import * as React from "react"
import {SelectSeeker} from "@ui-seeker/core";

import {GROUPED_BY} from "@constants"
import {errors, vision} from "@signals"


export const OPTIONS = [
	{ label: 'Market', value: GROUPED_BY.COUNTRY },
	{ label: 'Brand', value: GROUPED_BY.BRAND },
	{ label: 'Company', value: GROUPED_BY.COMPANY }
]

export default function VisionSelect({ ...props }) {
	return <SelectSeeker
		options={OPTIONS}
		error={errors.value?.vision}
		label="Vision"
		value={vision.value}
		onChange={e => vision.value = e.target.value}
		{...props}
	/>
}